<template>
  <Teleport to="body">
    <div v-if="mostrar" class="modal-overlay" @click="cerrar">
      <div class="modal-card" @click.stop>
        <div class="modal-header">
          <h2>⚠️ Pago requerido</h2>
          <button class="btn-close" @click="cerrar">✕</button>
        </div>
        
        <div class="modal-body">
          <p class="mensaje-principal">
            Para crear, editar o eliminar datos necesitas completar el pago.
          </p>

          <div class="selector-plan">
            <h3>Elegí tu plan:</h3>
            <div class="planes">
              <button
                class="plan-card"
                :class="{ activa: planSeleccionado === 'mensual' }"
                @click="planSeleccionado = 'mensual'"
                type="button"
              >
                <span class="plan-nombre">Mensual</span>
                <span class="plan-precio">$590 <small>UYU/mes</small></span>
              </button>
              <button
                class="plan-card"
                :class="{ activa: planSeleccionado === 'anual' }"
                @click="planSeleccionado = 'anual'"
                type="button"
              >
                <span class="plan-badge">2 meses gratis</span>
                <span class="plan-nombre">Anual</span>
                <span class="plan-precio">$5.900 <small>UYU/año</small></span>
                <span class="plan-equiv">equivale a $492/mes</span>
              </button>
            </div>
          </div>

          <div class="instrucciones">
            <p class="coordinar-texto">
              Para activar tu plan coordinamos el pago por WhatsApp: te paso los datos y, al
              confirmar la transferencia, tu cuenta queda activa.
            </p>
            <a :href="linkPagoWhatsapp" target="_blank" class="btn-whatsapp">
              💬 Coordinar pago por WhatsApp
            </a>
          </div>
        </div>

        <div class="modal-actions">
          <button class="btn-cancel" @click="cerrar">
            Cerrar
          </button>
        </div>
      </div>
    </div>

  </Teleport>
</template>

<script setup>
import { defineEmits, ref, computed } from 'vue';
import { linkWhatsApp } from '@/constants/contacto';
import { useScrollLock } from '@/composables/useScrollLock';

const props = defineProps({
  mostrar: {
    type: Boolean,
    default: false
  }
});

// Bloquea el scroll del fondo mientras el modal está abierto (igual que el resto
// de los modales). Sin esto, la página seguía scrolleando detrás del modal de pago.
useScrollLock(() => props.mostrar);

const emit = defineEmits(['cerrar']);

const planSeleccionado = ref('mensual');

const PRECIOS = {
  mensual: 590,
  anual: 5900,
};

const precio = computed(() => PRECIOS[planSeleccionado.value]);
const nombrePlan = computed(() => planSeleccionado.value === 'anual' ? 'Anual' : 'Mensual');

// Link de WhatsApp con el plan elegido, para coordinar el pago en privado.
const linkPagoWhatsapp = computed(() =>
  linkWhatsApp(`Hola Francisco, quiero activar mi cuenta de Vedent (plan ${nombrePlan.value}, $${precio.value} UYU) para seguir usándola. ¿Cómo coordino el pago?`)
);

function cerrar() {
  emit('cerrar');
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  padding: 16px;
}

.modal-card {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  font-family: system-ui, sans-serif;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  color: #f59e0b;
}

.btn-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6b7280;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s;
}

.btn-close:hover {
  background: #f3f4f6;
  color: #111827;
}

.modal-body {
  padding: 24px;
}

.mensaje-principal {
  font-size: 16px;
  color: #374151;
  margin-bottom: 20px;
  line-height: 1.5;
}

.instrucciones {
  background: #f9fafb;
  border-radius: 12px;
  padding: 20px;
}

.coordinar-texto {
  font-size: 14px;
  line-height: 1.5;
  color: #374151;
  margin: 0 0 14px;
}

.btn-whatsapp {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #25D366;
  color: #fff;
  text-decoration: none;
  padding: 14px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 15px;
}

.btn-whatsapp:hover {
  background: #1ebe5d;
}

.instrucciones h3 {
  margin: 0 0 16px 0;
  font-size: 16px;
  color: #111827;
}

.dato-bancario {
  margin-bottom: 12px;
}

.dato-bancario label {
  display: block;
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 4px;
  font-weight: 500;
}

.dato-bancario .valor {
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.dato-bancario .valor span {
  flex: 1;
  font-size: 14px;
  color: #111827;
  font-weight: 500;
}

.dato-bancario .valor.destacado {
  border: 2px solid #678AB2;
  background: #eff6ff;
}

.dato-bancario .valor.destacado span {
  color: #678AB2;
  font-weight: 700;
  font-size: 16px;
}

.btn-copiar {
  background: #678AB2;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-copiar:hover {
  background: #1d4ed8;
  transform: translateY(-1px);
}

.nota-importante {
  margin-top: 16px;
  padding: 16px;
  background: #fef3c7;
  border-radius: 8px;
  border: 1px solid #fbbf24;
}

.nota-importante p {
  margin: 8px 0;
  font-size: 13px;
  color: #78350f;
}

.nota-importante strong {
  color: #b45309;
}

.email-link {
  display: block;
  color: #678AB2;
  text-decoration: none;
  font-weight: 500;
  margin: 8px 0;
  font-size: 14px;
}

.email-link:hover {
  text-decoration: underline;
}

.tiempo {
  margin-top: 12px !important;
  font-style: italic;
  font-size: 12px !important;
  color: #92400e;
}

.modal-actions {
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: center;
}

.btn-cancel {
  background: #f3f4f6;
  color: #374151;
  border: none;
  padding: 12px 24px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.2s;
  font-family: system-ui, sans-serif;
}

.btn-cancel:hover {
  background: #e5e7eb;
}

/* Modal Alerta Personalizado */
.modal-overlay-alerta {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 4000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-alerta {
  background: white;
  width: 90%;
  max-width: 400px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: slideIn 0.2s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-alerta-header {
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
}

.modal-alerta-header.success {
  background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
}

.modal-icono {
  font-size: 24px;
}

.modal-alerta-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.modal-alerta-body {
  padding: 24px;
  color: #333;
  line-height: 1.6;
}

.modal-alerta-body p {
  margin: 0;
  font-size: 15px;
}

.modal-alerta-footer {
  padding: 16px 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  background: #f8f9fa;
  border-top: 1px solid #e5e7eb;
}

.btn-modal {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-aceptar {
  background: #678AB2;
  color: white;
}

.btn-aceptar:hover {
  background: #4d6f96;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(103, 138, 178, 0.3);
}

.selector-plan {
  margin-bottom: 20px;
}

.selector-plan h3 {
  margin: 0 0 12px 0;
  font-size: 16px;
  color: #111827;
}

.planes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.plan-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 14px;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  text-align: left;
  font-family: system-ui, sans-serif;
  transition: all 0.15s;
}

.plan-card:hover {
  border-color: #cbd5e1;
}

.plan-card.activa {
  border-color: #678AB2;
  background: #eff6ff;
  box-shadow: 0 0 0 3px rgba(103, 138, 178, 0.15);
}

.plan-nombre {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.plan-precio {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}

.plan-precio small {
  font-size: 11px;
  font-weight: 500;
  color: #6b7280;
}

.plan-equiv {
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px;
}

.plan-badge {
  position: absolute;
  top: -8px;
  right: 8px;
  background: #678AB2;
  color: white;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

@media (max-width: 420px) {
  .planes {
    grid-template-columns: 1fr;
  }
}
</style>
